export type CountryDial = {
  iso: string
  name: string
  dial: string
  flag: string
}

export const COUNTRY_DIALS: CountryDial[] = [
  { iso: 'HN', name: 'Honduras', dial: '+504', flag: '🇭🇳' },
  { iso: 'GT', name: 'Guatemala', dial: '+502', flag: '🇬🇹' },
  { iso: 'SV', name: 'El Salvador', dial: '+503', flag: '🇸🇻' },
  { iso: 'NI', name: 'Nicaragua', dial: '+505', flag: '🇳🇮' },
  { iso: 'CR', name: 'Costa Rica', dial: '+506', flag: '🇨🇷' },
  { iso: 'PA', name: 'Panamá', dial: '+507', flag: '🇵🇦' },
  { iso: 'BZ', name: 'Belice', dial: '+501', flag: '🇧🇿' },
  { iso: 'MX', name: 'México', dial: '+52', flag: '🇲🇽' },
  { iso: 'US', name: 'Estados Unidos', dial: '+1', flag: '🇺🇸' },
  { iso: 'ES', name: 'España', dial: '+34', flag: '🇪🇸' },
]

export const DEFAULT_DIAL = '+504'
export const OTHER_DIAL_KEY = '__other__'

const KNOWN_DIALS = COUNTRY_DIALS.map((c) => c.dial).sort(
  (a, b) => b.length - a.length,
)

export type PhoneParts = {
  /** Country dial (e.g. "+504") if matched against COUNTRY_DIALS, otherwise empty. */
  dial: string
  /** Local number portion (digits and separators only, no leading +). */
  local: string
  /** True when `value` is in +CC… form but the CC is not in COUNTRY_DIALS. */
  isOther: boolean
}

/** Split a stored E.164-ish phone into (dial, local). */
export function splitPhone(value: string | null | undefined): PhoneParts {
  const raw = (value || '').trim()
  if (!raw) return { dial: DEFAULT_DIAL, local: '', isOther: false }

  if (raw.startsWith('+')) {
    for (const dial of KNOWN_DIALS) {
      if (raw.startsWith(dial)) {
        return { dial, local: raw.slice(dial.length).trim(), isOther: false }
      }
    }
    // Unknown country code: best-effort split (assume +CC then rest).
    const match = raw.match(/^\+(\d{1,3})(.*)$/)
    if (match) {
      return { dial: `+${match[1]}`, local: match[2].trim(), isOther: true }
    }
  }

  // No + prefix: assume HN local format (8 digits).
  return { dial: DEFAULT_DIAL, local: raw, isOther: false }
}

/** Combine dial + local into an E.164-ish phone string. */
export function joinPhone(dial: string, local: string): string {
  const cleanedLocal = (local || '').replace(/[^\d]/g, '')
  if (!cleanedLocal) return ''
  const cleanedDial = (dial || DEFAULT_DIAL).trim()
  return `${cleanedDial}${cleanedLocal}`
}
